<template>
  <div class="container reference-help-layout">
    <aside class="reference-help-sidebar" aria-label="帮助导航">
      <details :open="isArticlePage">
        <summary>{{ currentPath === '/agent/help' ? '合营帮助' : '新手引导' }}</summary>
        <nav aria-label="帮助分类">
          <template v-if="isArticlePage">
            <button :class="{ active: activeHelpCategoryId === 0 }" :aria-current="activeHelpCategoryId === 0 ? 'page' : undefined" :disabled="helpLoading" @click="selectHelpCategory(0)">全部问题</button>
            <button v-for="category in helpCategories" :key="category.id" :class="{ active: activeHelpCategoryId === category.id }" :aria-current="activeHelpCategoryId === category.id ? 'page' : undefined" :disabled="helpLoading" @click="selectHelpCategory(category.id)">{{ category.name }}</button>
          </template>
          <button v-else @click="navigate('/help/center')">帮助中心</button>
        </nav>
      </details>
      <details :open="!isArticlePage">
        <summary>企业事务</summary>
        <nav aria-label="企业事务">
          <button v-for="item in documents" :key="item.path" :class="{ active: currentPath === item.path }" :aria-current="currentPath === item.path ? 'page' : undefined" @click="navigate(item.path)">{{ item.label }}</button>
        </nav>
      </details>
      <details>
        <summary>联系我们</summary>
        <nav aria-label="联系与合作"><button @click="navigate('/customer/main')">在线客服</button><button @click="navigate('/agent')">合营计划</button></nav>
      </details>
    </aside>

    <section class="reference-help-main" :aria-label="routeTitle[0]" :aria-busy="helpLoading">
      <div v-if="helpLoading && !helpArticles.length" class="help-state" role="status">正在获取帮助内容…</div>
      <div v-else-if="helpError" class="help-state error" role="alert"><b>帮助内容加载失败</b><span>{{ helpError }}</span><button type="button" @click="loadHelpData(currentPath)">重新获取</button></div>
      <template v-else-if="selectedHelpArticle">
        <button class="help-back" @click="closeHelpArticle">‹ 返回问题列表</button>
        <article class="reference-help-answer"><h3>{{ selectedHelpArticle.title }}</h3><a v-if="contentLink(selectedHelpArticle.content)" :href="contentLink(selectedHelpArticle.content)" target="_blank" rel="noopener noreferrer">查看帮助内容</a><div v-else class="help-rich-text" v-html="sanitizeHelpContent(selectedHelpArticle.content)" /></article>
      </template>
      <template v-else-if="helpArticles.length">
        <article v-for="article in helpArticles" :key="article.id" class="reference-help-answer">
          <h3>{{ article.title }}</h3>
          <a v-if="contentLink(article.content)" :href="contentLink(article.content)" target="_blank" rel="noopener noreferrer">查看帮助内容</a>
          <div v-else-if="article.content" class="help-rich-text" v-html="sanitizeHelpContent(article.content)" />
          <button v-else-if="isArticlePage" class="help-back" :disabled="helpArticleLoading" @click="openHelpArticle(article)">{{ helpArticleLoading ? '正在加载…' : '查看全文' }}</button>
        </article>
        <button v-if="isArticlePage && helpArticles.length < helpTotal" class="help-back" :disabled="helpLoading" @click="loadMoreHelp">{{ helpLoading ? '正在加载…' : '加载更多帮助' }}</button>
      </template>
      <div v-else class="help-state">当前分类暂无已发布内容</div>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppContext } from '../../composables/appContext'
import { safeExternalUrl } from '../../config/navigation.js'

const {
  activeHelpCategoryId, closeHelpArticle, currentPath, helpArticleLoading,
  helpArticles, helpCategories, helpError, helpLoading, helpTotal, loadMoreHelp, loadHelpData, navigate,
  openHelpArticle, routeTitle, sanitizeHelpContent, selectHelpCategory, selectedHelpArticle,
} = useAppContext()
const isArticlePage = computed(() => ['/help/center', '/agent/help'].includes(currentPath.value))
const documents = [
  { label: '关于我们', path: '/help/about' },
  { label: '规则与条款', path: '/help/terms' },
  { label: '隐私政策', path: '/help/privacy' },
  { label: '责任博彩', path: '/help/responsible' },
]
function contentLink(content) {
  return safeExternalUrl(String(content || '').trim())
}
</script>
